import React, { useState, useEffect } from 'react';
import './App.css'; // Import the default styles
import WeekButtons from './components/WeekButtons/WeekButtons';
import MatchupContainer from './components/MatchupContainer/MatchupContainer';
import { fetchData, fetchPicks, savePicks  } from './services/api';
import CountdownTimer from './components/Timer/Timer'
import {getTeams} from './Teams'; // Assuming you've placed the function in a separate file
import { fetchUserProfile2 } from './services/api';




function getCurrentDateIndex(dates) {

    const currentDate = new Date();
    const weeks = [];

    dates.forEach((dateRange, index) => {
        const [startDateStr, endDateStr] = dateRange.split(' - ');
        var year = "2026";
        if (startDateStr.includes("Jan") || startDateStr.includes("Feb")) {
            year = "2027";
        }
        const startDate = new Date(startDateStr + ", " + year);
        if (endDateStr.includes("Jan") || endDateStr.includes("Feb")) {
            year = "2027";
        }
        else {
            year = "2026";
        }
        const endDate = new Date(endDateStr + ", " + year);
        endDate.setDate(endDate.getDate() + 1); // Including end date
        weeks.push({ startDate, endDate });
    });

    var weekIndex = weeks.findIndex((week) => currentDate >= week.startDate && currentDate <= week.endDate);

    if (weekIndex === -1) {
        weekIndex = 0;
    }
    
    return weekIndex + 1;
}

const dates = [
    'Aug 1 - Sep 9',
            'Sep 10 - Sep 16',
            'Sep 17 - Sep 23',
            'Sep 24 - Sep 30',
            'Oct 1 - Oct 7',
            'Oct 8 - Oct 14',
            'Oct 15 - Oct 21',
            'Oct 22 - Oct 28',
            'Oct 29 - Nov 4',
            'Nov 5 - Nov 11',
            'Nov 12 - Nov 18',
            'Nov 19 - Nov 25',
            'Nov 26 - Dec 2',
            'Dec 3 - Dec 9',
            'Dec 10 - Dec 16',
            'Dec 17 - Dec 23',
            'Dec 24 - Dec 30',
            'Dec 31 - Jan 6',
            'Jan 7 - Jan 13',
            'Jan 14 - Jan 20',
            'Jan 21 - Jan 27',
            'May 1 - May 2',
            'Jan 28 - Feb 28',
];

const MatchupsPage = ({ db, onPageChange, enableNotifications, notificationsStatus }) => {

    const currentDateIndex = getCurrentDateIndex(dates);
    const [matchups, setMatchups] = useState([]);
    const [selectedWeek, setSelectedWeek] = useState(currentDateIndex); // Initial selected week
    const [selectedTeamIds, setSelectedTeamIds] = useState({}); // State to track selected teams
    const [picks, setPicks] = useState([]); // Declare the 'picks' array
    const [savedPicks, setSavedPicks] = useState({}); // Add this state
    const [teams, setTeams] = useState([]); // State to hold teams
    const [nchange, setnchange] = useState(0); // State to hold teams
    const [hiden, setHideN] = useState(false);
const [condensed, setCondensed] = useState(() => {
    const saved = localStorage.getItem("condensedView");
    return saved === "true"; // convert string -> boolean
  });


  useEffect(() => {
    localStorage.setItem("condensedView", condensed);
  }, [condensed]);
    const [savedProfile, setSavedProfile] = useState(JSON.parse(localStorage.getItem('profile')) || {});

    useEffect(() => {
        const getProfile = async () => {
            try {
                const u = await fetchUserProfile2(savedProfile.Email, setSavedProfile);
                setSavedProfile(u);
            }
            catch {

            }
        }
        getProfile();
    }, [notificationsStatus, nchange]);

    useEffect(() => {
        // Fetch teams when the component mounts
        getTeams()
            .then((t) => {
                setTeams(t);
            })
            .catch((error) => {
                console.error('Error fetching teams:', error);
                // Handle error gracefully
            });
    }, [db]);

    const footerClick = (page) => {
        onPageChange(page); // Update the current page in the App component
    };

    // Define handleWeekClick function
    const handleWeekClick = async (week) => {
        setSelectedWeek(week);
    };

    const [isLoading, setIsLoading] = useState(false); // State to track loading status

    // Define isStarted and isEnded states
    const [isStarted, setIsStarted] = useState(false);
    const [isEnded, setIsEnded] = useState(false);
    const [isPreseason, setIsPreseason] = useState(false);

    // Define start and end states
    const [start, setStart] = useState(null);

    const fetchAllData = async () => {
    const now = new Date();
    setIsLoading(true);

    try {
        // --- Fetch matchups ---
        const data = await fetchData(selectedWeek);
        const sortedEvents = data.events.sort((a, b) => new Date(a.date) - new Date(b.date));
        setMatchups(sortedEvents);

        // --- Compute timestamps ---
        let startTimestamp = new Date();
        let endTimestamp = new Date();
                    setIsPreseason(false);


        if (selectedWeek > 18) {
            const idx = Math.min(selectedWeek - 19, 4);
            startTimestamp = new Date(data.leagues[0].calendar[2].entries[idx].startDate);
            startTimestamp.setDate(startTimestamp.getDate() - 1);
            endTimestamp = new Date(data.leagues[0].calendar[2].entries[idx].endDate);
        } else if (selectedWeek < 0) {
            setIsPreseason(true);
            setIsStarted(false);
        } else {
            startTimestamp = new Date(data.leagues[0].calendar[1].entries[selectedWeek - 1].startDate);
            startTimestamp.setDate(startTimestamp.getDate() - 0);
            startTimestamp.setHours(startTimestamp.getHours() - 3);
            //startTimestamp.setMinutes(startTimestamp.getMinutes() - 59);
            //startTimestamp.setSeconds(startTimestamp.getSeconds() - 15);
            endTimestamp = new Date(data.leagues[0].calendar[1].entries[selectedWeek - 1].endDate);
            endTimestamp.setHours(endTimestamp.getHours() - 7);
        }

        if (selectedWeek >= 0) {
            setStart(startTimestamp);
            setIsStarted(now.getTime() > startTimestamp.getTime());
            setIsEnded(now.getTime() > endTimestamp.getTime());
        }

        // --- Fetch picks ---
        setPicks([]);
        setSavedPicks([]);
        setSelectedTeamIds({});
        await fetchPicks(selectedWeek, setPicks, setSelectedTeamIds, setSavedPicks);

    } catch (error) {
        console.error('Error fetching data:', error);
    } finally {
        setIsLoading(false);
    }
};

useEffect(() => {
    fetchAllData();
}, [selectedWeek]);



    const handleTeamClick = (pick, matchupId, val, date) => {

        if ((date < new Date() || !(val > 0))) {
            return null;
        }
        else {
            setSelectedTeamIds((prevSelectedTeamIds) => {
                return {
                    ...prevSelectedTeamIds,
                    [matchupId]: { "pick": pick, "val": val },
                };
            });

            setPicks((prevPicks) => {
                const newPicks = { ...prevPicks };

                if (newPicks[matchupId] && newPicks[matchupId].pick !== pick) {
                    // If the pick for this matchupId was already saved and it's being changed, reduce savedPicks count
                    setSavedPicks((prevSavedPicks) => {
                        const updatedSavedPicks = { ...prevSavedPicks };
                        delete updatedSavedPicks[matchupId]; // Remove the old pick
                        return updatedSavedPicks;
                    });
                }

                newPicks[matchupId] = { "pick": pick, "val": val };
                return newPicks;
            });
        }
    };

    const enable = async () => {
        try{
            setHideN(true);
            await enableNotifications();
        setnchange(Math.random());
        }
        catch{
            setHideN(false);
        }
        

    }
    
    const confirmationDiv = document.getElementById('confirmation');

    const handleSaveClick = async () => {
        const profile = JSON.parse(localStorage.getItem('profile'));
        const user = profile.Email;
        try {
            await savePicks(picks, user, selectedWeek);
            setSavedPicks(picks);
            // Show confirmation div
            confirmationDiv.style.display = 'block';
            // Fade out after 3 seconds
            setTimeout(() => {
                confirmationDiv.style.display = 'none';
            }, 3000);
        } catch (error) {
            console.error('Error saving picks:', error);
        }
    };

    if (matchups.length < 1) {
        return <div></div>;
    }

    const userprofile = JSON.parse(localStorage.getItem('profile'));

    return (
        <div>
            <WeekButtons status={`${isLoading ? 'loading' : ''}`} handleWeekClick={handleWeekClick} />
            <div className={!isStarted ? (isPreseason ? `matchups-page page preseason unclickable ${condensed ? 'condensed' : ''}` :  `matchups-page page unclickable ${condensed ? 'condensed' : ''}`) : `matchups-page page ${condensed ? 'condensed' : ''}`}>
            {isLoading && (
                <div key={"loader-doner"}>
                    
                    <div key={"loader-boder"} className="loader"></div>
                </div>
            )} 

            {!isLoading && (
                    <>
                        {!isStarted ? (
                            !isPreseason ? (
                                <div className="banner">
                                    OPENS IN <CountdownTimer start={start} onComplete={fetchAllData} />
                                </div>
                            ) : (
                                <div className="banner">
                                    PRESEASON - PICKS DISABLED
                                </div>
                            )
                        ) : isEnded ? (
                            null
                            /*<div className="banner">WEEK CLOSED</div>*/
                        ) : null}
                        {selectedWeek == 100 ? (
                            <div className="matchup-container dark-news" onClick={() => footerClick(`nfl-teams`)}>
                                <div className="image"><img src="Group 17.png" /></div>
                                <div className="content"><div className="heading">Preseason Team Rankings</div>
                                    <div className="description">Click to View</div></div>
                            </div>
                        ) : null}
                        {/*
                            <div className="matchup-container dark-news" onClick={() => footerClick(`groups`)}>
                                <div className="image"><img src="Group 17.png" /></div>
                                <div className="content"><div className="heading">Join a Group!</div>
                                    <div className="description">Click to View</div></div>
                            </div>
                        */}

                       {/* <div className="warning">
                    notificationsStatus == "denied" && <div className="notificationsDenied">Please turn on Notifications for this App</div>
                </div>*/}
                

                {/*(notificationsStatus != "denied" && !hiden && (notificationsStatus != "granted" || !(savedProfile.subscriptions !== null && savedProfile.subscriptions?.length > 0))) && <div id="enable-notifications">
                <h3>Enable Notifications</h3>
                <p>Please enable notifications for important reminders and alerts</p>
                <button onClick={() => enable()}>Allow</button>
            </div>
                        <button className="matchups-page-button" onClick={() => setCondensed(!condensed)}>{condensed ? "Change to Traditional View" : "Change to Condensed View"}</button>*/}

                        {matchups.map((matchup, index) => {

                                            const date = new Date(matchup.date);
                const dayName = date.toLocaleDateString([], { weekday: 'long' });

                            const currentDay = date.toDateString();
                            const showDayHeader = index === 0 || new Date(matchups[index - 1].date).toDateString() !== currentDay;
                            return (
                                <>
                            {showDayHeader && <div className="day-header">{dayName}</div>}

                            <MatchupContainer
                                key={matchup.id}
                                preseason={isPreseason}
                                matchup={matchup}
                                handleTeamClick={handleTeamClick}
                                selectedTeamIds={selectedTeamIds}
                                teams={teams}
                                onPageChange={onPageChange}
                                type="nfl"

                            /></>)
                        })}

                        <div id="confirmation">Picks Saved.</div>

                       {((!isEnded && isStarted) || false) ? (
                        <div className="save-section">
                            <div className="save-subsection">
                                    
                                    <button id="mainsave" onClick={handleSaveClick}>
                                        Update Picks
                                    </button>
                            </div>
                            <div className="save-subsection">
                                    <div className="pickProgress">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="40" width="40" viewBox="0 0 20 20">
                                                <circle r="5" cx="10" cy="10" stroke="#666" strokeWidth="5" />
                                                <circle r="5" cx="10" cy="10" stroke="#aaa" strokeWidth="5" strokeDasharray={`calc(${100 * Object.keys(picks).length / matchups.length} * 31.42 / 100) 31.42`} transform="rotate(-90) translate(-20)" />
                                                <circle r="5" cx="10" cy="10" stroke="white" strokeWidth="5" strokeDasharray={`calc(${100 * Object.keys(savedPicks).length/matchups.length} * 31.42 / 100) 31.42`} transform="rotate(-90) translate(-20)" />

                                                <circle r="5" cx="10" cy="10" strokeWidth="2" fill={Object.keys(savedPicks).length == matchups.length ? "white" : "black"} />
                                          <line x1="7" y1="10.5" x2="9.25" y2="12.75" strokeWidth="1" />
                                           <line x1="9" y1="12.5" x2="13" y2="8.5" strokeWidth="1" />
                                        </svg>
                                        {Math.min(Object.keys(savedPicks).length, 16)}/{Math.min(matchups.length, 16)} Saved
                                    </div>
                                
                            </div>
                        </div>) : null }
                    </>

            )}
            </div>
        </div>
    );
};

export default MatchupsPage;
